import Vue from 'vue';
import MyAccount from './MyAccount.vue';

new Vue({
  components: {
    MyAccount,
  },
  // router,
  // i18n: store.state.lang.i18n,
  template: '<my-account></my-account>',
}).$mount('#my-account-vue-app');
